import axiosHelper from '../utils/axios';
import ZoneModel from '../models/zone';
import Zone from '../models/zone';
import ZoneCategory from '../models/zoneCategory';

export default (() => {
    const networkAssetPath = "/networkAsset/airfinder/";

    async function getZonesBySite(siteId, hiddenLoader = false){
        const response = await axiosHelper.getNetworkAsset().get(`${networkAssetPath}zones?siteId=${siteId}`);
		return response.data;
    }

    async function getZones(siteId, hiddenLoader = false){
        const response = await axiosHelper.getNetworkAsset(hiddenLoader ? 'hideLoadingIndicator' : '').get(`${networkAssetPath}zones?siteId=${siteId}`);
		return response.data.map(zone => new Zone().normalize(zone));
    }

    async function getZoneByArea( areaId, hiddenLoader = false ) {
        const response = await axiosHelper
        .getNetworkAsset(hiddenLoader ? 'hideLoadingIndicator' : '')
        .get(`${networkAssetPath}zones?areaId=${areaId}`);

        return response.data.map(zone => new ZoneModel().normalize(zone));
    }
    async function getZoneById(zoneId){
        const response = await axiosHelper.getNetworkAsset().get(`${networkAssetPath}zone/${zoneId}`);
        return new ZoneModel().normalize(response.data);
    }
    async function createZone(zone) {
        const response = await axiosHelper.getNetworkAsset().post(`${networkAssetPath}zones`, zone);
        return new ZoneModel().normalize(response.data);
    }
    async function editZone(zone) {        
        const response = await axiosHelper.getNetworkAsset().put(`${networkAssetPath}zone/${zone.id}`, zone.data);
        return new ZoneModel().normalize(response.data);
    }
    async function deleteZone(zoneId) {
        const response = await axiosHelper.getNetworkAsset().delete(`${networkAssetPath}zone/${zoneId}`);
        return response.data;
    }
    async function getZoneCategories(siteId, hiddenLoader = false){
        const response = await axiosHelper.getNetworkAsset(hiddenLoader ? 'hideLoadingIndicator' : '').get(`${networkAssetPath}zoneCategory/${siteId}`);
        return response.data.map(category => new ZoneCategory().normalize(category));
    }
    async function createZoneCategory(zoneCategory) {
        const response = await axiosHelper.getNetworkAsset().post(`${networkAssetPath}zoneCategory`, zoneCategory);
        return new ZoneCategory().normalize(response.data);
    }
    async function deleteZoneCategory(zoneCategoryId) {
        const response = await axiosHelper.getNetworkAsset().delete(`${networkAssetPath}zoneCategory/${zoneCategoryId}`);
        return response.data;
    }
	return {
        getZones,
        getZonesBySite,
        getZoneByArea,
        getZoneById,
        createZone,
        editZone,
        deleteZone,
        getZoneCategories,
        createZoneCategory,
        deleteZoneCategory
	}

})();